import React, { useState, useEffect } from "react";
import Footer from '../Components/Footer';
import {
  Box,
  Container,
  Grid,
  TextField as TextF,
  MenuItem,
  Typography,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import { useHistory } from "react-router-dom";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Textfield from '../Components/FormsUI/Textfield';
import Button from '../Components/FormsUI/Button';
import background from './new.png'
import logo from './02.png'
import logo2 from './logo.svg'
import { green } from "@material-ui/core/colors";


const useStyles = makeStyles((theme) => ({
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "white !important",
    color: 'white !important'
  },
  root: {
    '& .MuiFormLabel-root.Mui-disabled': {
      color: 'red',
    },
  },
}));

const INITIAL_FORM_STATE = {
  studentRoll: '',
  collegeCode: '',
};

const FORM_VALIDATION = Yup.object().shape({
  studentRoll: Yup.string()
    .required('Student ID/SSC Roll Roll is Required'),
  collegeCode: Yup.string()
    .required('Institute ID/EIIN No is Required'),
});



const SchoolList = (props) => {
  const classes = useStyles();

  const [check, setCheck] = useState(false)
  const [message, setMessage] = useState('')

  const history = useHistory();

  async function handleClass(evt) {
    history.push("/online-applicant-info/" + parseInt(evt.target.value));
  }


  const [loading, setLoading] = React.useState(false);
  async function submitata(values) {


    if (values.collegeCode === 1000035) {
      values.collegeCode = 10214;
    }

    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_API_ROOT}/public/student/list/by/custom-id?customStudentId=${values.studentRoll}&instituteId=${values.collegeCode}`)
    response = await response.json()
    //console.log(response.item)
    if (response?.item?.length === 1) {
      sessionStorage.setItem('info', JSON.stringify(response?.item?.[0]));
      let response2 = await fetch(`${process.env.REACT_APP_API_ROOT}/public/subject/list/by/class-id/group-id?classId=${response?.item?.[0].classId}&groupId=${response?.item?.[0].groupId}&instituteId=${response?.item?.[0].instituteId}`)
      response2 = await response2.json();
      history.push("/online-applicant-info/" + response?.item?.[0]?.instituteId);
      if (response2?.item?.length > 0) {
        sessionStorage.setItem('subinfo', JSON.stringify(response2?.item));

      }
      // const requestx = new Request(`${process.env.REACT_APP_API_ROOT}/public/confirmation/letter/download/for/college?identificationId=${response?.item?.[0].identificationId}&instituteId=${response?.item?.[0].instituteId}`, {
      //   headers: new Headers({'Content-Type': 'application/octet-stream'})
      // });
      // const responsex = await fetch(requestx);
      // console.log(responsex)
      setCheck(false);
      setLoading(false);
    } else {
      setMessage(response?.message || 'Something went wrong');
      setCheck(true);
      setLoading(false);
    }
  }



  return (

    <>
      <img src={logo} style={{ height: 170, width: "100%" }} />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '74vh', backgroundImage: "url(" + background + ")", width: "100%", backgroundRepeat: "no-repeat", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
      >



        <br></br>
        <Box
          minHeight="250px"
          minWidth="400px"
          border={1}
          borderColor="white"
          borderRadius="12px"
        >
          <div style={{ textAlign: "center", padding: 20, background: "#fff", boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)", borderRadius: 10 }}>
            <img src={logo2} style={{ height: 100 }} />
            <Typography variant="h4" component="h4" style={{ color: "#009688", textAlign: "center" }}>
              Online Admission
            </Typography>

            <Typography variant="h6" component="h6" style={{ color: "#009688", textAlign: "center" }}>
              (Admission /Registration /Form fillup)
            </Typography>
            <br></br>

            <Formik
              initialValues={{
                ...INITIAL_FORM_STATE
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={values => {
                //console.log(values)
                submitata(values);
              }}
            >
              {(formikProps) => {
                const { values, handleChange } = formikProps;
                return (
                  <Form
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        submitata(values);
                      }
                    }}
                  >
                    <Textfield
                      name="studentRoll"
                      label="Student ID/SSC Roll"
                    />
                    <br></br>
                    <br></br>
                    <Textfield
                      name="collegeCode"
                      label="Institute ID/EIIN No"
                      type="number"

                    />
                    <br></br>
                    <br></br>
                    {check &&
                      <>
                        <Typography variant="h6" component="h6" style={{ color: "red" }}>
                          {message}
                        </Typography>
                        <br></br>
                      </>}
                    {loading && (
                      <CircularProgress
                        size={24}
                        sx={{
                          color: green[500],
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          marginTop: '-12px',
                          marginLeft: '-12px',
                        }}
                      />
                    )}
                    <Button >Submit</Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </Box>

      </Grid>
    </>
  );
};

export default SchoolList;